var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReemEleven(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 52,
    viewBox: "0 0 102 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.412 23L49.102 19.598H48.36V23H45.98V13.2H50.348C51.384 13.2 52.2007 13.494 52.798 14.082C53.4047 14.6607 53.708 15.4587 53.708 16.476C53.708 17.9787 53.0547 18.9447 51.748 19.374L54.324 23H51.412ZM51.3 16.504C51.3 15.8133 50.894 15.468 50.082 15.468H48.36V17.512H50.082C50.894 17.512 51.3 17.176 51.3 16.504ZM62.4077 15.468H58.0397V16.924H62.0157V19.192H58.0397V20.732H62.4077V23H55.6597V13.2H62.4077V15.468ZM70.6245 15.468H66.2565V16.924H70.2325V19.192H66.2565V20.732H70.6245V23H63.8765V13.2H70.6245V15.468ZM79.2053 13.2H81.9073V23H79.5273V16.532L77.0773 20.27H76.8533L74.4033 16.532V23H72.0233V13.2H74.7253L76.9653 16.56L79.2053 13.2ZM52.728 30.468H48.36V31.924H52.336V34.192H48.36V35.732H52.728V38H45.98V28.2H52.728V30.468ZM56.5768 35.732H60.5528V38H54.1968V28.2H56.5768V35.732ZM68.6284 30.468H64.2604V31.924H68.2364V34.192H64.2604V35.732H68.6284V38H61.8804V28.2H68.6284V30.468ZM76.1032 28.2H78.6232L75.5292 38H72.5332L69.4672 28.2H71.9872L74.0452 35.116L76.1032 28.2ZM86.7026 30.468H82.3346V31.924H86.3106V34.192H82.3346V35.732H86.7026V38H79.9546V28.2H86.7026V30.468ZM94.2894 28.2H96.6694V38H93.9674L90.2854 31.826L90.4814 33.898V38H88.1014V28.2H90.8034L94.4714 34.374L94.2894 32.302V28.2Z",
    fill: "#3C373A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_657_1754)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6072 24.1883C35.5028 22.1515 36 19.8992 36 17.5306C36 8.40101 28.6127 1 19.5 1C10.3873 1 3 8.40101 3 17.5306C3 19.4631 3.33098 21.3181 3.93925 23.0418L3.91699 23.041C3.98013 23.1946 4.04442 23.3487 4.10984 23.5032C4.29607 23.9845 4.50414 24.4549 4.73284 24.9132C8.10427 32.2465 13.8023 40.2916 19.5003 46.0002C25.6878 39.8012 32.242 29.8829 34.6253 24.189L34.6072 24.1883Z",
    fill: "#3C373A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.4999,
    cy: 16.3216,
    rx: 9.42857,
    ry: 9.42857,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_657_1754",
    x: 0,
    y: 1,
    width: 39,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_657_1754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_657_1754",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReemEleven);
export default __webpack_public_path__ + "static/media/Reem Eleven.5deb7005e8f2fd74c2b0ad883a46eb88.svg";
export { ForwardRef as ReactComponent };